import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const HistorySlider = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);

  // Add image for each slide
  const historyData = [
    {
      title: t("history_h1"),
      content: t("history_h1_para"),
      image: "./images/slider-1.jpg",
    },
    {
      title: t("history_h2"),
      content: t("history_h2_para"),
      image: "./images/slider-2.jpg",
    },
    {
      title: t("history_h3"),
      content: t("history_h3_para"),
      image: "./images/slider-3.jpg",
    },
    {
      title: t("history_h4"),
      content: t("history_h4_para"),
      image: "./images/slider-2.jpg",
    },
    {
      title: t("history_h5"),
      content: t("history_h5_para"),
      image: "./images/slider-1.jpg",
    },
    {
      title: t("history_h6"),
      content: t("history_h6_para"),
      list: [t("1"), t("2"), t("3")],
      extra: t("history_h6_2_para"),
      image: "./images/slider-2.jpg",
    },
  ];

  const nextSlide = () => {
    if (currentIndex < historyData.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const current = historyData[currentIndex];

  return (
    <div className="col-md-12">
      <div>

        {/* Navigation */}
        <div
          style={{
            marginBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <button
            onClick={prevSlide}
            disabled={currentIndex === 0}
            style={buttonStyle}
          >
            ← Previous
          </button>

          <button
            onClick={nextSlide}
            disabled={currentIndex === historyData.length - 1}
            style={buttonStyle}
          >
            Next →
          </button>
        </div>

        {/* Image */}
        {current.image && (
          <div style={{ marginBottom: "20px" }}>
            <img
              src={current.image}
              alt={current.title}
              style={imageStyle}
            />
          </div>
        )}

        {/* Heading */}
        <h3 className="historyheadeg">{current.title}</h3>

        {/* Content */}
        <p
          className="hcontent"
          
        >
          {current.content}
        </p>

        {/* List */}
        {current.list && (
          <ol className="hcontent" style={{ marginLeft: "25px" }}>
            {current.list.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ol>
        )}

        {/* Extra */}
        {current.extra && (
          <p className="hcontent">
            {current.extra}
          </p>
        )}

        {/* Indicator */}
        <div style={{ textAlign: "center", marginTop: "15px" }}>
          {currentIndex + 1} / {historyData.length}
        </div>

      </div>
    </div>
  );
};

// Styles
const buttonStyle = {
  padding: "10px 20px",
  borderRadius: "6px",
  border: "none",
  backgroundColor: "#8B0000",
  color: "#fff",
  cursor: "pointer",
  fontFamily:"manjari"
};

const imageStyle = {
  width: "100%",
  height: "300px",
  objectFit: "cover",
  borderRadius: "10px",
};

export default HistorySlider;